import { render, staticRenderFns } from "./AssocForestPlot.vue?vue&type=template&id=0d3119a4&"
import script from "./AssocForestPlot.vue?vue&type=script&lang=ts&"
export * from "./AssocForestPlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports